import { Form, type FormInstance } from 'antd';
import type { ProdutoLocalEstoque } from '@/features/produto-local-estoque/types/ProdutoLocalEstoque';
import type { FormProdutoValues } from '@/features/produto/types/FormProdutoValues';
import type { ProdutoBodyLote } from '@/features/produto/types/ProdutoBody';
import type { Dialog } from '@/std/dialog/types';
import { TableDefault } from '@/components/antd/TableDefault';
import { findItemAndIndex } from '@/std/array';
import { produtoTabEstoqueLoteTableColumns } from './produtoTabEstoqueLoteTableColumns';

export function ProdutoTabEstoqueLoteTable({
    dialog,
    form,
    locais,
    setFormDirty,
}: {
    dialog: Dialog<ProdutoBodyLote>;
    form: FormInstance<FormProdutoValues>;
    locais: ProdutoLocalEstoque[];
    setFormDirty: (dirty: boolean) => void;
}) {
    const lotesForm: ProdutoBodyLote[] = Form.useWatch('lote', form) ?? [];
    const lotes = lotesForm.filter((lote) => lote.excluir !== 'S');

    const onDelete = (row: ProdutoBodyLote): void => {
        const lote = findItemAndIndex(lotesForm, (item) => item.key === row.key);
        if (!lote) {
            return;
        }

        if (lote.item.prl_idpk) {
            form.setFieldValue(['lote', lote.index, 'excluir'], 'S');
        } else {
            form.setFieldValue(
                'lote',
                lotesForm.filter((item) => item.key !== row.key),
            );
        }

        setFormDirty(true);
        void form.validateFields(['produto_estoque']).catch(() => undefined);
    };

    return (
        <TableDefault
            columns={produtoTabEstoqueLoteTableColumns({
                locais,
                onDelete,
                onEdit: (row) => dialog.actions.edit(row),
            })}
            dataSource={lotes}
            pagination={false}
            rowKey='key'
        />
    );
}
